import { Button, Text, YStack } from "@/components";

type CallTrayButtonProps = {
  onPress: () => void;
  Icon: React.ElementType;
  text: string;
  backgroundColor?: string;
  ariaLabel?: string;
};

const CallTrayButton = ({
  onPress,
  backgroundColor = "$fillCallControl",
  Icon,
  text,
  ariaLabel,
}: CallTrayButtonProps) => {
  return (
    <YStack
      flex={1}
      alignItems="center"
      borderBottomLeftRadius="$150"
      borderBottomRightRadius="$150"
    >
      <Button.Wrapper
        aria-label={ariaLabel ?? text}
        backgroundColor={backgroundColor}
        borderRadius={100_000}
        padding="$200"
        marginBottom="$50"
        hoverStyle={{
          opacity: 0.9,
        }}
        onPress={onPress}
      >
        <Icon size={24} color="$textOnCall" />
      </Button.Wrapper>
      <Text
        size="$sm"
        color="$textOnCall"
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {text}
      </Text>
    </YStack>
  );
};

export default CallTrayButton;
